module.exports = __webpack_public_path__ + "img/collection-weddingRingsTensionRings@2x.11d383e.webp";